import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { SelfServiceSchedule } from '../types/SelfServiceSchedule';

export type RefreshTargetType = 'Workbook' | 'Datasource' | 'Mixed';
// No idea why typescript thinks typeof ALL_REFRESH_TASK_TYPES is just string, but it does
export type RefreshTaskType = 'RefreshExtract' | 'IncrementExtract';
export const ALL_REFRESH_TASK_TYPES: RefreshTaskType[] = ['RefreshExtract', 'IncrementExtract'];

export type ExtractServiceRefreshType = 'ExtractServiceFullRefresh';

export interface CreateExtractTasksSelfServiceSchedulesRequestParams {
  schedule: SelfServiceSchedule;
  scheduleName: string;
  targetIds: number[];
  targetType: Omit<RefreshTargetType, | 'Mixed'>;
  type: RefreshTaskType | ExtractServiceRefreshType;
}

export class CreateExtractTasksSelfServiceSchedulesRequest extends Request<CreateExtractTasksSelfServiceSchedulesRequestParams, IResult> {
  constructor(params: CreateExtractTasksSelfServiceSchedulesRequestParams) {
    super('createExtractTasksSelfServiceSchedules', params);
  }
}
